import type { AxiosResponse } from 'axios'
import { RtnCode } from '@library/enums'
import type { ApiResponse } from './types'

/**
 * 將 fetch 回應包裝成 ApiResponse 格式，以便使用 apiValidator 進行驗證
 */
export async function wrapFetchResponse<T>(
  response: Response
): Promise<ApiResponse<T>> {
  const data = await response.json()

  const baseResponse = {
    status: response.status,
    statusText: response.statusText,
    headers: Object.fromEntries(
      response.headers as unknown as Iterable<[string, string]>
    ),
    config: { headers: {} } as AxiosResponse['config'],
    request: undefined
  }

  if (response.ok) {
    return {
      ...baseResponse,
      data: {
        rtnCode: RtnCode.CODE_SUCCESS,
        message: 'Success',
        pagination: null,
        sort: null,
        data
      }
    }
  }

  return {
    ...baseResponse,
    data: {
      rtnCode: RtnCode.EVA_API_FAILURE,
      message: response.statusText,
      pagination: null,
      sort: null,
      data: null
    }
  }
}
